import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { styled } from 'styled-components';

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  border-top: 1px solid #a4907c;
  margin-top: 70px;
  @media screen and (min-width: 768px) {
    display: block;
  }
  @media screen and (min-width: 1280px) {
    margin-top: 140px;
  }
`;

export const FooterBox = styled.div`
  display: block;
  gap: 40px;
  max-width: 1440px;

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const HoursList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 30px;
  @media screen and (min-width: 768px) {
    align-items: flex-start;
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const HoursListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const HoursListItemText = styled.p`
  color: black;
  font-family: 'Aboreto', sans-serif;
  font-size: 17px;
  text-align: center;
  line-height: normal;

  @media screen and (min-width: 1280px) {
    font-size: 20px;
  }
`;

export const ContactsList = styled.ul``;

export const ContactsListItem = styled.li`
  display: flex;
  justify-content: center;

  @media screen and (min-width: 768px) {
    display: block;
  }
  &:nth-child(1) {
    margin-bottom: 10px;
  }

  &:nth-child(2) {
    margin-bottom: 10px;
  }
`;

export const ContactsListItemLink = styled.a`
  color: black;
  font-family: 'Aboreto', sans-serif;
  font-size: 17px;
  text-align: center;
  line-height: normal;
  text-decoration: none;

  @media screen and (min-width: 1280px) {
    font-size: 20px;
  }
`;

export const ContactsListItemLinkBox = styled.div`
  display: flex;
  justify-content: center;
`;

export const AddressList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  gap: 20px;
`;

export const AddressListItem = styled.li``;

export const AddressListItemText = styled.p`
  color: black;
  font-family: 'Aboreto', sans-serif;
  font-size: 17px;
  line-height: normal;
  text-decoration: none;
  text-align: center;
  &:last-child {
    margin-top: 10px;
  }
  @media screen and (min-width: 1280px) {
    font-size: 20px;
  }
`;

export const InstagramIcon = styled(FaInstagram)`
  width: 22px;
  height: 22px;
  @media screen and (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

export const FacebookIcon = styled(FaFacebook)`
  width: 22px;
  height: 22px;
  @media screen and (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

export const AddressListItemIframe = styled.iframe`
  width: 100%;
  height: 200px;
  border: 0;
  @media screen and (min-width: 768px) {
    width: 600px;
    height: 200px;
  }
`;

// export const HoursList = styled.div``;
// export const HoursList = styled.div``;
// export const HoursList = styled.div``;
